import { render, staticRenderFns } from "./shipAddress.vue?vue&type=template&id=965a0fb4"
import script from "./shipAddress.vue?vue&type=script&lang=js"
export * from "./shipAddress.vue?vue&type=script&lang=js"
import style0 from "./shipAddress.vue?vue&type=style&index=0&id=965a0fb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports